module.exports = __webpack_public_path__ + "media/images/countryrect/ve-905cc32300203a68a976364040f77824.svg";